// extracted by mini-css-extract-plugin
export default {"content":"Layout_content__QWkJl","content_no_user":"Layout_content_no_user__FhFqm"};